export default "__VITE_PUBLIC_ASSET__6d553fb0__"